import { combineReducers } from 'redux'
import list from './list'
import edit from './edit'
import info from './info'

export default combineReducers({
  list,
  edit,
  info,
})
